import { Check } from 'lucide-react'
import React, { FC } from 'react'
import styled from 'styled-components'
import { Form781AData } from 'types'

const FormList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 0.25rem;
`

const FormCheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem 0;
  cursor: pointer;
  user-select: none;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }

  &[data-disabled='true'] {
    cursor: not-allowed;
    opacity: 0.5;
  }
`

const CheckboxBox = styled.div<{ $checked: boolean; $disabled: boolean }>`
  width: 16px;
  height: 16px;
  min-width: 16px;
  border-radius: 3px;
  border: 1.5px solid
    ${({ $checked }) =>
      $checked ? 'rgba(59, 130, 246, 0.9)' : 'rgba(255, 255, 255, 0.3)'};
  background-color: ${({ $checked }) =>
    $checked ? 'rgba(59, 130, 246, 0.2)' : 'rgba(0, 0, 0, 0.3)'};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  svg {
    width: 12px;
    height: 12px;
    color: rgba(59, 130, 246, 1);
    opacity: ${({ $checked }) => ($checked ? 1 : 0)};
    transition: opacity 0.2s ease;
  }
`

const CheckboxLabel = styled.span`
  font-size: 0.875rem;
  color: rgba(255, 255, 255, 0.9);
`

const EmptyState = styled.div`
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.5);
  font-style: italic;
  padding: 0.5rem 0;
`

interface Form781AEntry {
  id: string
  data: {
    formData?: Form781AData
  }
}

interface Form781ASelectorProps {
  inProgressForms: Form781AEntry[]
  isFormChecked: (formId: string) => boolean
  toggleFormSelection: (formId: string) => void
  disabled?: boolean
}

export const Form781ASelector: FC<Form781ASelectorProps> = ({
  inProgressForms,
  isFormChecked,
  toggleFormSelection,
  disabled = false,
}) => {
  if (inProgressForms.length === 0) {
    return <EmptyState>No in-progress forms available</EmptyState>
  }

  return (
    <FormList>
      {inProgressForms.map((form) => {
        const formName =
          form.data.formData?.name || `Form ${form.id.slice(0, 8)}` // first 8 chars of GUID
        const checked = isFormChecked(form.id)

        return (
          <FormCheckboxWrapper
            key={form.id}
            onClick={() => !disabled && toggleFormSelection(form.id)}
            data-disabled={disabled}>
            <CheckboxBox $checked={checked} $disabled={disabled}>
              <Check />
            </CheckboxBox>
            <CheckboxLabel>{formName}</CheckboxLabel>
          </FormCheckboxWrapper>
        )
      })}
    </FormList>
  )
}
